import apcApi from "./api/apcApi";

// export const getCountryStateMappingData = async (
//   setCountryStateMappingData,
//   callback
// ) =>
//   await new Promise((resolve, reject) => {
//     const headers = {
//       "Cache-Control": "no-cache",
//       Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
//       "x-api-key": "exchange_spr",
//       "x-gw-ims-email": "sjayaraj+fujitesting16@adobetest.com",
//     };
//     apcApi
//       .get("/api/v1/apc/all/d365/options", { headers })
//       .then((response) => {
//         setCountryStateMappingData(response.data);
//         if (callback) {
//           callback();
//         }
//         resolve(response.data);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });

export const getCountryStateMappingData = async (
  setCountryStateMappingData,
  callback,
) => {
  const headers = {
    "Cache-Control": "no-cache",
    Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
    "x-api-key": "exchange_spr",
  };
  return await apcApi
    .get("/api/v1/apc/all/d365/options", { headers })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);

      return {
        isError: true,
      };
    });
};
